import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["title"];
import * as React from 'react';
export default (function (_ref) {
  var title = _ref.title,
    extra = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement("svg", _extends({
      width: "50",
      height: "40.919",
      viewBox: "0 0 50 40.919"
    }, extra), title, /*#__PURE__*/React.createElement("path", {
      d: "M37.474 0c-2.296 0-4.28 1.879-4.28 4.28 0 .835.209 1.67.73 2.296l-8.976 12.317H8.247c-.626-1.67-2.192-2.714-3.967-2.714-2.296 0-4.28 1.88-4.28 4.28 0 2.297 1.88 4.28 4.28 4.28 1.775 0 3.34-1.044 3.967-2.714h16.91l16.597 13.152c-.209.417-.313.94-.313 1.461 0 2.297 1.879 4.28 4.28 4.28 2.296 0 4.28-1.879 4.28-4.28 0-2.296-1.88-4.28-4.28-4.28-.731 0-1.357.21-1.984.522l-15.97-12.63 8.559-11.69c.417.104.73.104 1.148.208 2.296 0 4.28-1.879 4.28-4.28C41.649 1.878 39.77 0 37.474 0z"
    }))
  );
});